import { FC } from "react";

import Table from "../../../components/Table";
import Text from "../../../components/Text";
import { Trade } from "../../../types/Trade";

import { ImageIcon } from "../../../assets/img/icons";
import Stat from "../../../components/Text/Stat";
import Tooltip from "../../../components/Tooltip";
import styles from "./styles.module.scss";

type Props = {
    isLoading: boolean;
    trades: Trade[];
    className?: string;
    onTradeClick?: (tradeId: string) => void;
    images: Record<string, string | undefined>;
};

const TradesTable: FC<Props> = ({
    isLoading,
    trades,
    className,
    onTradeClick,
    images,
}) => {
    const formatTradingSessions = (trades: Trade[]) => {
        return trades.map((trade) => {
            const { result } = trade;

            return {
                ...trade,
                result: <Stat type="currency">{result}</Stat>,
                coherentPlan: trade.coherentPlan ? "Oui" : "Non",
                comment: trade.comment ? (
                    <Tooltip
                        content={
                            <div className={styles.tooltipChild}>
                                <Text variant="body">{trade.comment}</Text>
                            </div>
                        }
                    >
                        <Text maxLength={24} variant="body-bold">
                            {trade.comment}
                        </Text>
                    </Tooltip>
                ) : (
                    "-"
                ),
                isImage: images[trade.id] ? (
                    <div className={styles.imageIconColumn}>
                        <ImageIcon />
                    </div>
                ) : (
                    <></>
                ),
                onClick: () => onTradeClick?.(trade.id),
            };
        });
    };

    return (
        <Table
            loading={isLoading}
            className={`${className}`}
            rows={[
                { label: "GAIN / PERTE", value: "result" },
                { label: "METHODE RESPECTEE", value: "coherentPlan" },
                { label: "COMMENTAIRE", value: "comment" },
                { label: "", value: "isImage", width: 42 },
            ]}
            data={formatTradingSessions(trades)}
        />
    );
};

export default TradesTable;
